<template>
  <article>
    <header
            v-if="page.title && page?.meta?.hideTitle !== true"
            class="mb-8"
    >
      <h2 :class="headerClass">
        {{ page.title }}
      </h2>
    </header>
    <ContentRenderer
            :class="contentClass"
            :value="page"
            class="with-free-text mb-12"
    />
    <div
            v-if="!noCta && page?.meta.cta"
            class="text-center mb-12"
    >
      <ButtonCta
              v-if="page?.meta?.cta"
              :cta="page.meta.cta"
              class="inline-block btn-brand"
      />
    </div>
    <picture
            v-if="imgUri"
            :class="pictureClass"
    >
      <media-source
              :dimensions="imgDimensions"
              :sizes="imgSizes"
              :uri="imgUri"
              as="source"
              format="webp"
      />
      <media-source
              :alt="page.title"
              :class-name="`w-full h-auto object-cover rounded-img ${imgAspectRatio}`"
              :dimensions="imgDimensions"
              :sizes="imgSizes"
              :uri="imgUri"
              as="img"
              format="jpg"
      />
    </picture>
  </article>
</template>
<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";

const {
    page,
    contentClass = 'text-center',
    headerClass = 'section-title text-center',
    imgSizes = '100vw',
    pictureClass = 'w-full',
    imgDimensions = [
        {width: 480},
        {width: 960},
        {width: 1440},
        {width: 1920},
    ],
    imgAspectRatio = '',
    noCta = false,
} = defineProps<{
    page: PageCollectionItemBase;
    contentClass?: string;
    pictureClass?: string;
    headerClass?: string;
    imgDimensions?: { width: number, height?: number }[];
    imgSizes?: string;
    imgAspectRatio?: string;
    noCta?: boolean;
}>();
const imgUri = computed<string>(() => (page.meta?.imageRef as string || '').replace('/assets', ''));
</script>